<div class="">
    <div *ngFor="let step of steps; index as i" class="step">
        <div *ngIf="step.stepId < 18">
            <div *ngIf="step.stepNumber > 0" class="group">
                <div *ngIf="step.stepId < 10" class="box">
                    <i *ngIf="stepNumberSelected > step.stepNumber" class="box ri-check-line step-box-number-selected"></i>

                    <span *ngIf="stepNumberSelected === step.stepNumber" class="box step-box-number-selected">{{ step.stepNumber }}</span>
                    <span *ngIf="stepNumberSelected < step.stepNumber" class="box step-box-number-inactive">{{ step.stepNumber }}</span>
                </div>

                <div *ngIf="step.stepId == 10 && stepIdSelected == 18" class="box">
                    <i *ngIf="stepIdSelected == 18 && stepNumberSelected == 6" class="box ri-check-line step-box-number-selected"></i>
                </div>

                <div *ngIf="step.stepId == 10 && stepIdSelected == 19" class="box">
                    <i *ngIf="stepIdSelected == 19 && stepNumberSelected == 6" class="box ri-check-line step-box-number-selected"></i>
                </div>

                <div *ngIf="step.stepId == 10 && stepIdSelected < 18" class="box">
                    <span *ngIf="stepNumberSelected === step.stepNumber" class="box step-box-number-selected">{{ step.stepNumber }}</span>
                    <span *ngIf="stepNumberSelected < step.stepNumber" class="box step-box-number-inactive">{{ step.stepNumber }}</span>
                </div>

                <div *ngIf="step.stepId <= 10" class="step-name">
                    <span *ngIf="stepNumberSelected > step.stepNumber" class="step-name-selected">{{ step.stepName | translate }}</span>
                    <span *ngIf="stepNumberSelected === step.stepNumber" class="step-name-selected">{{ step.stepName | translate }}</span>
                    <span *ngIf="stepNumberSelected < step.stepNumber" class="step-name-inactive">{{ step.stepName | translate }}</span>
                </div>
            </div>

            <div *ngIf="stepNumberSelected > step.stepNumber && step.stepNumber > 0" class="line-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="2" height="32" viewBox="0 0 2 32" fill="none">
                    <path class="line-container-step-completed" d="M1 0L1 32" stroke="#3C3C3B" />
                </svg>
            </div>

            <div *ngIf="stepNumberSelected <= step.stepNumber && step.stepNumber < steps.length - 3 && step.stepNumber > 0" class="line-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="2" height="32" viewBox="0 0 2 32" fill="none">
                    <path class="line-container-step-inactive" d="M1 0L1 32" stroke="#F5F5F7" />
                </svg>
            </div>
        </div>

        <div *ngIf="step.stepId >= 20">
            <div *ngIf="step.stepNumber > 0" class="group">
                <div *ngIf="step.stepNumber > 0 && stepNumberSelected > step.stepNumber" class="box">
                    <i class="box ri ri-check-line step-box-number-selected"></i>
                </div>

                <div *ngIf="step.stepNumber > 0 && stepNumberSelected === step.stepNumber" class="box">
                    <i *ngIf="step.stepNumber == 1" class="box ri ri-bank-line step-box-number-selected"></i>
                    <i *ngIf="step.stepNumber == 2" class="box ri ri-pencil-line step-box-number-selected"></i>
                    <i *ngIf="step.stepNumber == 3" class="box ri ri-webcam-line step-box-number-selected"></i>
                    <i *ngIf="step.stepNumber == 4" class="box ri ri-upload-cloud-2-line step-box-number-selected"></i>
                </div>

                <div *ngIf="step.stepNumber > 0 && stepNumberSelected < step.stepNumber" class="box">
                    <i *ngIf="step.stepNumber == 1" class="box ri ri-check-line step-box-number-inactive"></i>
                    <i *ngIf="step.stepNumber == 2" class="box ri ri ri-pencil-line step-box-number-inactive"></i>
                    <i *ngIf="step.stepNumber == 3" class="box ri ri-webcam-line step-box-number-inactive"></i>
                    <i *ngIf="step.stepNumber == 4" class="box ri ri-upload-cloud-2-line step-box-number-inactive"></i>
                </div>

                <div *ngIf="step.stepNumber > 0 && stepNumberSelected >= step.stepNumber" class="step-name">
                    <span *ngIf="stepNumberSelected >= step.stepNumber" class="step-name-selected">{{ step.stepName | translate }}</span>
                </div>

                <div *ngIf="step.stepNumber > 0 && stepNumberSelected < step.stepNumber" class="step-name">
                    <span *ngIf="stepNumberSelected < step.stepNumber" class="step-name-inactive">{{ step.stepName | translate }}</span>
                </div>
            </div>

            <div *ngIf="stepNumberSelected > step.stepNumber && step.stepNumber > 0" class="line-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="2" height="32" viewBox="0 0 2 32" fill="none">
                    <path d="M1 0L1 32" stroke="#3C3C3B" />
                </svg>
            </div>

            <div *ngIf="stepNumberSelected <= step.stepNumber && step.stepNumber < steps.length - 1 && step.stepNumber > 0" class="line-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="2" height="32" viewBox="0 0 2 32" fill="none">
                    <path d="M1 0L1 32" stroke="#F5F5F7" />
                </svg>
            </div>
        </div>
    </div>
</div>
